import * as React from 'react'
import { RefObject, useEffect, useRef, useState } from 'react'
import { Grid, Alert, Box } from '@mui/material'
import { useParams, useHistory } from 'react-router-dom'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faTimesCircle } from '@fortawesome/pro-duotone-svg-icons/faTimesCircle'
import { faPenToSquare } from '@fortawesome/pro-duotone-svg-icons/faPenToSquare'

import { toast } from 'react-toastify'
import { ToastOptions } from 'react-toastify/dist/types'
import DefaultGrid from '@/feature/Grid/DefaultGrid'
import LoadingPage from '@/shared/composed-ui/LoadingPage'
import { LoadingDefault } from '@/shared/ui/loading'
import EntityHelper from '../../../util/EntityHelper'
import {
    IDisplayPositionList,
    useEntityService,
} from '../../../context/EntityServiceContext'
import DisplayItemHelper from '../../../util/DisplayItemHelper'
import { StyledButton } from '@/shared/ui/buttons'

const MultiUpdateContentDossier = ({ kedo, props }) => {
    const toastOptions = {
        position: 'bottom-center',
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    } as ToastOptions
    const params = useParams()
    const entityService = useEntityService()
    const [defDossier, setDefDossier] = useState(null)
    const [loading, setLoading] = useState(false)
    const [showSaveSuccess, setShowSaveSuccess] = useState(false)
    const [denied_error, setDenied_error] = useState(false)
    const [ignoreWarning, setIgnoreWarning] = useState(false)
    const [embedded, setEmbedded] = useState(false)
    const [saved, setSaved] = useState(false)
    const [changed, setChanged] = useState({})
    const [submitting, setSubmitting] = useState(false)
    const [redirect, setRedirect] = useState(false)
    const [edit, setEdit] = useState(true)
    const [content, setContent] = useState({})
    const [mainPos, setMainPos] = useState({})
    const [errors, setErrors] = useState({})
    const [items, setItems] = useState([])
    const [id, setId] = useState(
        props.defDossierId ? props.defDossierId : params.id
    )
    const refs = useRef([])
    let curRef = useRef(null)

    const fetchDisplayPositions = async (defDossierId) => {
        const dpUrl =
            kedo.api().getDisplayPositionEndpoint() +
            '?defDossier=' +
            defDossierId
        return await kedo.api().get(dpUrl)
    }

    const fetchDisplayItems = async () => {
        const ddiParams = {
            params: {
                view: ['edit', 'show/edit'],
                defDossier: id,
                displayPosition: ['main_content'],
                sort: ['rank', 'col'],
                sortOrder: ['ASC', 'ASC'],
            },
        }

        setLoading(true)

        const ddPositions = (await entityService.getDisplayPositions(
            id
        )) as IDisplayPositionList

        const entity = (await entityService.getEntity(id)) as Entity

        const mainPos = ddPositions.results.find(
            (dpItem) => dpItem.type === 'main_content'
        )

        setDefDossier(entity)
        setMainPos(mainPos)

        const roleIds = kedo
            .env()
            .getCurrentEnvironmentRoles()
            .map((item) => item.id)

        setItems(
            DisplayItemHelper.filterViews(mainPos.display_items, [
                DisplayItemHelper.EDIT_VIEW,
                DisplayItemHelper.SHOW_EDIT_VIEW,
            ]).filter((item) => {
                if (
                    !item.permissions_type ||
                    kedo.isAdminOrEnvironmentAdmin()
                ) {
                    return true
                }

                if (item.permissions_type === 'INCLUDE_SELECTED_ROLES') {
                    if (
                        item.roles.filter((roleItem) =>
                            roleIds.includes(roleItem.role.id)
                        ).length > 0
                    ) {
                        return true
                    } else {
                        return false
                    }
                } else if (item.permissions_type === 'EXCLUDE_SELECTED_ROLES') {
                    if (
                        item.roles.filter((roleItem) =>
                            roleIds.includes(roleItem.role.id)
                        ).length <= 0
                    ) {
                        return true
                    } else {
                        return false
                    }
                }

                return true
            })
        )
        setLoading(false)
    }

    const getCurrentRef = (): RefObject<any> => {
        if (!curRef) {
            curRef = React.createRef()
        }

        return curRef
    }

    const onChangeValue = (itemId, value, item) => {
        //TODO KeDo: Check conditions here.
        //TODO KeDo: Check other modules here and maybe change data based on
    }

    const dossierMultiUpdate = () => {
        setSubmitting(true)

        const values = getCurrentRef().current.getValues()

        if (ignoreWarning === true) {
            values['ignore_existing'] = true
        }

        values.defDossier = id

        const submitErrors = EntityHelper.checkCanSubmitDisplayPosition(
            kedo,
            defDossier,
            mainPos,
            getCurrentRef(),
            values,
            ignoreWarning
        )

        if (Object.keys(submitErrors).length > 0) {
            setErrors(submitErrors)
            setSubmitting(false)
            const errorId = checkErrors(submitErrors)
            getCurrentRef().current.doFocus(errorId)
            return
        }

        const payload = {
            overwrite: props.overwrite,
            defDossier: parseInt(values.defDossier),
            update_values: values,
            dossier_ids: props.selectedDossierIds,
        }

        kedo.api()
            .put(kedo.api().getMassUpdateEndpoint(), payload)
            .then((response) => {
                setRedirect(
                    props.location === 'Block'
                        ? false
                        : props.selectedDossierIds[0]
                )
                setEdit(false)
                setSubmitting(false)
                setErrors([])

                toast.success(
                    kedo.t('dossier_errors.success_create'),
                    toastOptions
                )
            })
            .catch((error) => {
                if (error.response && error.response.status === 409) {
                    setErrors(error.response.data.errors)
                    setSubmitting(false)
                } else if (error.response && error.response.status === 403) {
                    setDenied_error(kedo.t('not_allowed_to_create_dossier'))
                    setSubmitting(false)

                    toast.error(
                        kedo.t('dossier_errors.permission_create'),
                        toastOptions
                    )
                    window.scrollTo(0, 0)
                } else {
                    toast.error(
                        kedo.t('dossier_errors.error_create'),
                        toastOptions
                    )
                    setErrors(error.response.data.errors)
                    setSubmitting(false)

                    const errorId = checkErrors(false)
                    getCurrentRef().current.doFocus(errorId)
                }
            })
    }

    const getAllValues = () => {
        const values = getCurrentRef().current.getValues()
        if (props.embedded && props.embedded !== true) {
            values['embedded'] = props.embedded
            values['linkId'] = props.linkId
        }

        return values
    }

    const preSubmitDossier = () => {
        dossierMultiUpdate()
    }

    const renderButtons = () => {
        return (
            <Box sx={{ float: 'right' }}>
                <StyledButton
                    disabled={submitting ? true : false}
                    type="submit"
                    onClick={() => preSubmitDossier()}
                    title="Update"
                >
                    {submitting ? (
                        <LoadingDefault size={'sm'} as={'span'} />
                    ) : (
                        <FontAwesomeIcon icon={faPenToSquare} />
                    )}
                    &nbsp; {kedo.t('Update')}
                </StyledButton>{' '}
                &nbsp;
                <StyledButton
                    color="secondary"
                    title={kedo.t('Cancel')}
                    onClick={() => props.onClose()}
                >
                    <FontAwesomeIcon icon={faTimesCircle} />
                    &nbsp; {kedo.t('Cancel')}
                </StyledButton>
            </Box>
        )
    }

    const renderSuccessAlert = () => {
        return (
            <Alert key={'success'} severity={'success'}>
                &nbsp; {kedo.t('Dossier has been saved successfully')}
            </Alert>
        )
    }

    const checkErrors = (errors) => {
        const values = []
        const newItems = []
        items
            .filter((item) => item.view === 'edit' || item.view === 'show/edit')
            .map((item) => newItems.push(item))

        newItems.map((filterItem) => {
            values.push({
                id: filterItem.id,
                type: filterItem.def_dossier_def_field
                    ? filterItem.def_dossier_def_field.def_field.type
                    : filterItem.def_dossier_link,
                error: errors ? errors[filterItem.id] : errors[filterItem.id],
            })
        })

        const focusItem = values.find((item) => item.error)

        if (focusItem) {
            return focusItem.id
        }
    }

    useEffect(() => {
        fetchDisplayItems()
    }, [])

    if (redirect !== false) {
        if (props.embedded) {
            // this.props.onSuccess(this.state.redirect);
            return ''
        }
        return <Redirect to={`/contentdossier/${redirect}`} />
    }

    if (!defDossier || loading || id !== params.id) {
        return <LoadingPage />
    }

    return (
        <Grid container>
            <Grid size={12}>
                {denied_error !== false ? (
                    <Alert severity={'warning'}>{denied_error}</Alert>
                ) : null}
                {saved === true ? (
                    <Alert severity={'success'}>
                        {kedo.t('Dossier has been saved successfully')}
                    </Alert>
                ) : null}
                <div
                    className={
                        props.location === 'EmbeddedLinkField'
                            ? ''
                            : 'mainContainer'
                    }
                >
                    {showSaveSuccess === true ? renderSuccessAlert() : null}
                    {props.location === 'EmbeddedLinkField' ? null : (
                        <Grid container alignItems="flex-start" spacing={2}>
                            <Grid size={{ xs: 12, sm: 'grow' }}>
                                <h1>
                                    {props.multiAdd ? (
                                        <small>Multi add </small>
                                    ) : null}
                                    {kedo.t('Mass update')}{' '}
                                    {kedo
                                        .env()
                                        .translateItem(
                                            defDossier,
                                            'defdossier'
                                        )}
                                </h1>
                            </Grid>
                            {items.length ? (
                                <Grid
                                    size={{ xs: 12, sm: 'auto' }}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    {renderButtons()}
                                </Grid>
                            ) : null}
                        </Grid>
                    )}
                    <div>
                        {props.multiAdd ? (
                            <Alert severity={'info'}>
                                {kedo.t('multi_add_dossier_header')}
                            </Alert>
                        ) : null}
                        <DefaultGrid
                            changeValue={onChangeValue}
                            conditions={
                                defDossier &&
                                defDossier.settings &&
                                defDossier.settings.conditions
                                    ? defDossier.settings.conditions
                                    : []
                            }
                            content={content}
                            embedded={props.embedded}
                            linkId={props.linkId}
                            errors={errors}
                            hiddenfields={
                                defDossier &&
                                defDossier.settings &&
                                defDossier.settings.hiddenfields
                                    ? defDossier.settings.hiddenfields
                                    : []
                            }
                            items={items}
                            kedo={kedo}
                            mode={'edit'}
                            ref={getCurrentRef()}
                            multiUpdate={true}
                        />
                        <Grid container>
                            <Grid size={12}>{renderButtons()}</Grid>
                        </Grid>
                    </div>
                </div>
            </Grid>
        </Grid>
    )
}

export default MultiUpdateContentDossier
